import(/* webpackMode: "eager" */ "/home/runner/work/frontend-monorepo/frontend-monorepo/apps/curology-sign-up/src/app/[brand]/error.tsx");
